import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import Header from "./Header";

// Context
import { useTranslation } from "react-i18next";

export default function Tutorials() {
  const { t } = useTranslation();

  const YOUTUBE_VIDEOS = [
    {
      id: "1",
      title: t("tutorials.linkWhatsApp"),
      videoId: t("tutorials.linkWhatsAppUrl"),
    },
    {
      id: "2",
      title: t("tutorials.firstMessage"),
      videoId: t("tutorials.firstMessageUrl"),
    },
    {
      id: "3",
      title: t("tutorials.importContacts"),
      videoId: t("tutorials.importContactsUrl"),
    },
    {
      id: "4",
      title: t("tutorials.variables"),
      videoId: t("tutorials.variablesUrl"),
    },
    {
      id: "5",
      title: t("tutorials.birthdayMessages"),
      videoId: t("tutorials.birthdayMessagesUrl"),
    },
    {
      id: "6",
      title: t("tutorials.broadcastLists"),
      videoId: t("tutorials.broadcastListsUrl"),
    },
    {
      id: "7",
      title: t("tutorials.bulkMessages"),
      videoId: t("tutorials.bulkMessagesUrl"),
    },
    {
      id: "8",
      title: t("tutorials.bulkMessagesFile"),
      videoId: t("tutorials.bulkMessagesFileUrl"),
    },
    {
      id: "9",
      title: t("tutorials.ai"),
      videoId: t("tutorials.aiUrl"),
    },
    {
      id: "10",
      title: t("tutorials.useApi"),
      videoId: t("tutorials.useApiUrl"),
    },
  ];

  return (
    <Box m="20px">
      <Header title={t("tutorials.title")} subtitle={t("tutorials.subtitle")} />
      <Grid container spacing={2} mt={2}>
        {YOUTUBE_VIDEOS.map((video) => (
          <Grid item xs={12} sm={6} md={4} key={video.id}>
            <Card
              sx={{ cursor: "pointer" }}
              onClick={() =>
                window.open(
                  `https://www.youtube.com/watch?v=${video.videoId}`,
                  "_blank"
                )
              }
            >
              <CardMedia
                component="img"
                height="200"
                image={`https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`}
                alt={video.title}
              />
              <CardContent>
                <Typography variant="h6" fontWeight="bold">
                  {video.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
